<template>
  <div class="container">
    <ControlGroup v-if="!countryScorecard">
      <Dropdown
        :options="['Region', 'Category']"
        label="Show policies by"
        v-model="mode"
      />
    </ControlGroup>
    <Tabs>
      <Tab title="Snapshot">
        <PolicySnapshot
          v-if="mode === 'Region'"
          :countries="countryList"
          :debug="debug"
        />
        <PolicySnapshot
          v-if="mode === 'Category'"
          :countries="countryList"
          showAll
          :debug="debug"
        />
      </Tab>
      <Tab title="All policies">
        <DataGetter
          :url="`${apiRoute}/policies/v2/`"
          :params="{ topic: ['Critical Minerals'] }"
          :formatter="formatPolicies"
          v-slot="{ data }"
        >
          <SortableTable
            animated
            :headers="[
              mode === 'Region'
                ? {
                    key: 'country',
                    label: 'Region',
                    sortable: true,
                    align: 'left',
                  }
                : {
                    key: 'category',
                    label: 'Category',
                    sortable: true,
                    align: 'left ',
                  },
              { key: 'title', label: 'Name', sortable: true, align: 'left' },
              { key: 'year', label: 'Start year', sortable: true },
              {
                key: 'type',
                label: 'Policy type',
                sortable: false,
                align: 'center',
              },
              { key: 'status', label: 'Status', sortable: true },
            ]"
            linkField="title"
            :items="data"
          />
        </DataGetter>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {
  DataGetter,
  ControlGroup,
  Tabs,
  Tab,
  Dropdown,
  SortableTable,
} from "@international-energy-agency/vue-ui";
import PolicySnapshot from "./components/PolicySnapshot.vue";
import policyTypes from "./data/policyTypes";
import countryList from "./data/countryList";

export default {
  name: "MineralsScorecard",
  components: {
    DataGetter,
    ControlGroup,
    Dropdown,
    SortableTable,
    Tabs,
    Tab,
    PolicySnapshot,
  },
  props: {
    countryScorecard: {
      type: Boolean,
      default: false,
    },
    debug: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiRoute: this.debug ? "https://api.test.iea.org" : "https://api.iea.org",
      countryList,
      mode: "Region",
    };
  },
  methods: {
    setCountries(data) {
      data.forEach((policy) => {
        if (!this.countries.includes(policy.country)) {
          this.countries.push(policy.country);
        }
        this.countries.sort();
        this.selectedCountry = this.countries[0];
      });
    },
    getCategory(policy) {
      const matchingPolicyType = Object.keys(policyTypes).find((policyType) => {
        const params = policyTypes[policyType].reduce((params, subCategory) => {
          Object.keys(subCategory.params).forEach((subParam) => {
            if (params[subParam]) {
              params[subParam] = [
                ...params[subParam],
                ...subCategory.params[subParam],
              ];
            } else {
              params[subParam] = subCategory.params[subParam];
            }
          });
          return params;
        }, {});
        let excluded = false;
        Object.keys(params).forEach((testParam) => {
          const policyParam = policy[testParam];
          if (Array.isArray(policyParam)) {
            excluded =
              excluded ||
              !policyParam.some((value) => params[testParam].includes(value));
          } else {
            excluded = !params[testParam].includes(policyParam);
          }
        });
        return excluded;
      });
      return matchingPolicyType || "";
    },
    getLink(policy) {
      return `${policy.policyID}-${policy.title}`
        .toLowerCase()
        .replace(/_/g, "-")
        .replace(/@/g, "at")
        .match(
          /[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ0-9\s-]+/g
        )
        .join("")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    formatPolicies(data) {
      return data.map((policy) => ({
        ...policy,
        year: `${policy.year}`, // convert to string to avoid number formatting
        type: policy.type.join(", "),
        category: this.getCategory(policy),
        href: `https://www.iea.org/policies/${this.getLink(policy)}`,
      }));
    },
  },
};
</script>

<style>
.list__container {
  display: flex;
}
.list__sidebar {
  flex: 1 0 400px;
  background: red;
}
.m-policy-listing container {
  flex: 1 1 auto;
}
</style>
